import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import NotificationBell from "./NotificationBell";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const dash = user && user.role === "employer" ? "/employer" : user && user.role === "admin" ? "/admin" : user && user.role === "flex" ? "/flex" : "/candidate";

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5">
          <img src="/darriker-logo.png" alt="Darriker" className="w-9 h-9 object-contain" />
          <span className="leading-none">
            <span className="block font-display font-black text-xl tracking-tighter">Darriker</span>
            <span className="block font-mono2 text-[10px] uppercase tracking-wider text-[#4B5563] -mt-0.5">
              GlobalHire<span className="text-[#002FA7]">.AI</span>
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7 text-sm font-medium">
          <Link to="/" className={loc.pathname === "/" ? "text-[#002FA7]" : "hover:text-[#002FA7]"}>
            Platform
          </Link>
          <Link to="/pricing" data-testid="nav-pricing" className="hover:text-[#002FA7]">
            Pricing
          </Link>
          <Link to="/jobs" data-testid="nav-jobs" className={loc.pathname.startsWith("/jobs") ? "text-[#002FA7]" : "hover:text-[#002FA7]"}>
            Jobs
          </Link>
          <Link to="/marketplace/onsite" data-testid="nav-flex" className={loc.pathname === "/marketplace/onsite" ? "text-[#002FA7]" : "hover:text-[#002FA7]"}>
            Darriker Flex
          </Link>
          <Link to="/marketplace/remote" data-testid="nav-remote" className={loc.pathname === "/marketplace/remote" ? "text-[#002FA7]" : "hover:text-[#002FA7]"}>
            Darriker Remote
          </Link>
          <Link to="/marketplace/health" data-testid="nav-health" className={loc.pathname === "/marketplace/health" ? "text-[#0E7C66]" : "hover:text-[#0E7C66]"}>
            Darriker Health
          </Link>
          {user && (
            <Link to={dash} data-testid="nav-dashboard" className="hover:text-[#002FA7]">
              Dashboard
            </Link>
          )}
          {user && (
            <Link to="/account" data-testid="nav-account" className="hover:text-[#002FA7]">
              Account
            </Link>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <NotificationBell />
              <span className="hidden sm:inline font-mono2 text-xs uppercase text-[#4B5563]">
                {user.role}
              </span>
              <button
                data-testid="nav-logout"
                onClick={() => {
                  logout();
                  nav("/");
                }}
                className="btn-outline px-4 py-2 text-sm font-medium rounded-none"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link
                to="/auth"
                data-testid="nav-login"
                className="px-4 py-2 text-sm font-medium hover:text-[#002FA7]"
              >
                Log in
              </Link>
              <Link
                to="/auth?mode=register"
                data-testid="nav-get-started"
                className="btn-ink px-4 py-2 text-sm font-medium rounded-none"
              >
                Get started
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
